export default class InitializationManager {
    private elementMap: Map<string, Set<HTMLElement>> = new Map();

    public add(group: string) {
        if(!this.elementMap.has(group)) {
            this.elementMap.set(group, new Set());
        }
    }

    public addElement(group: string, element: HTMLElement) {
        this.add(group);
        if(!this.elementMap.has(group)) {
            this.elementMap.set(group, new Set());
        }

        this.elementMap.get(group)!.add(element);
    }

    public has(group: string): boolean {
        return this.elementMap.has(group);
    }

    public hasElement(group: string, element: HTMLElement): boolean {
        return this.elementMap.has(group) && this.elementMap.get(group)!.has(element) ? true : false;
    }

    public delete(group: string) {
        if (this.elementMap.has(group)) {
            this.elementMap.delete(group);
        }
    }

    public deleteElement(group: string, element: HTMLElement) {
        if (this.elementMap.has(group)) {
            this.elementMap.get(group)!.delete(element);
        }
    }
}


